var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty, Collection } from '@syncfusion/ej2-base';
import { DayWorkingTime } from '../models/day-working-time';
/**
 * Defines the working time of the day in the project.
 */
export class WeekWorkingTime extends ChildProperty {
}
__decorate([
    Property()
], WeekWorkingTime.prototype, "dayOfWeek", void 0);
__decorate([
    Collection([], DayWorkingTime)
], WeekWorkingTime.prototype, "timeRange", void 0);
